import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const DynamicCKEditor = ({ data = "", onChange, config = {} }) => {
  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={data || ""}
        onChange={onChange}
        config={{
          toolbar: [ "heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "undo", "redo","imageUpload"], ...config,
        }}
      />
    </div>
  );
};

export default DynamicCKEditor;
